import { createShareLoops, isOpaqueShareToken, assertShareCardPayload } from './shareLoops.mjs'
import { requireUser, supabase } from './supabase'

const WORKER_URL = import.meta.env.VITE_WORKER_URL || 'https://fragrance-fetch.rbarbs23.workers.dev'

const shareLoops = createShareLoops(supabase)

async function workerJson(path, options = {}) {
  const response = await fetch(`${WORKER_URL}${path}`, options)
  const data = await response.json().catch(() => ({}))
  if (!response.ok) throw new Error(data.error || 'Could not load this recommendation.')
  return data
}

export async function fetchShareCardPayload(fragranceId) {
  if (!fragranceId) throw new Error('A fragrance is required to build a share card.')

  await requireUser()
  return shareLoops.prepare(fragranceId)
}

export const recordSharedByMe = payload => shareLoops.confirm(payload)

export async function resolveShareReferral(token, includeRecipe = false) {
  if (isOpaqueShareToken(token)) {
    if (includeRecipe) {
      try {
        const { data, error } = await supabase.rpc('resolve_recipe_share', { p_token: token })
        if (!error && data?.kind === 'combination') return data
      } catch { /* A missing recipe migration must preserve fragrance shares. */ }
    }
    return shareLoops.resolve(token)
  }
  const payload = await workerJson(`/share/referral?token=${encodeURIComponent(token)}`)
  return assertShareCardPayload(payload)
}

export async function recordSignupAttribution(token, signupUserId) {
  if (!token || !signupUserId) return null
  if (isOpaqueShareToken(token)) {
    try {
      const { data, error } = await supabase.rpc('record_recipe_share_recipient', { p_token: token })
      if (!error && data) return data
    } catch { /* Fall through for pre-migration and fragrance tokens. */ }
    return shareLoops.signup(token, signupUserId)
  }
  return workerJson('/share/signup-attribution', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token, signup_user_id: signupUserId }),
  })
}
